import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ShipmentEntity } from '../../domain/entities/ShipmentEntity'
import { ShipmentStatusLogEntity } from '../../domain/entities/ShipmentStatusLogEntity'
import type { ShipmentStatusLogAdminDto } from '@/backend/market'

export class ShipmentStatusModel extends ShipmentStatusLogEntity {
  constructor(dataDto: ShipmentStatusLogAdminDto) {
    super()
    mapEntityProperties<ShipmentEntity>(this, dataDto)
  }
}
